import { AxiosError } from 'axios';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { getOrElse } from '../utils';

export function ErrorMessage(error: AxiosError & { messageId?: string }): string | ReactNode {
    const { messageId = 'common.errorText' } = error;
    return getOrElse(error.response && error.response.data, error.response?.data, <FormattedMessage id={messageId} />);
}
